module.exports = __webpack_public_path__ + "static/media/design.b321ba0e.png";